import { render, staticRenderFns } from "./IconDelet.vue?vue&type=template&id=3420fcd4&scoped=true&"
import script from "./IconDelet.vue?vue&type=script&lang=js&"
export * from "./IconDelet.vue?vue&type=script&lang=js&"
import style0 from "./IconDelet.vue?vue&type=style&index=0&id=3420fcd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420fcd4",
  null
  
)

export default component.exports